import * as actionTypes from 'constants/ActionTypes';

const flagCompliance = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
    case actionTypes.GET_FLAG_COMPLIANCE.REQUEST:
        return {
            ...state,
        };
    case actionTypes.GET_FLAG_COMPLIANCE.SUCCESS: {
        return {
            ...state,
            items: action.data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_FLAG_COMPLIANCE.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };

    default:
        return state;
    }
};

export default flagCompliance;



// WEBPACK FOOTER //
// ./app/reducers/flagCompliance.js